import classNames from 'classnames'
import React, {memo} from 'react'

import usePipelineRunJobProgress from './PipelineRunJobProgress.hooks'
import type {PipelineRunJobProgressProps} from './PipelineRunJobProgress.types'

import styles from './PipelineRunJobProgress.css'

function PipelineRunJobProgress({mainPercentage, builds, status}: PipelineRunJobProgressProps) {
  const {progressPercentages, progresBarHeight} = usePipelineRunJobProgress(mainPercentage, builds)
  const progresBarClassNames = classNames(styles.progresBar, {
    [styles.progressFailure]: status === 'failure',
    [styles.progressSuccess]: status === 'success',
  })

  return (
    <div className={styles.progres}>
      {progressPercentages.map((percentag, index) => {
        const key = `key_${index}`
        return (
          <div
            className={progresBarClassNames}
            key={key}
            style={{width: `${percentag}%`, height: `${progresBarHeight}%`}}
          />
        )
      })}
    </div>
  )
}

export default memo(PipelineRunJobProgress)
